import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/partialSearchResults', request, cancelToken)
}

export {get}
